import { useContext } from 'react';
import NotificationsContext from './NotificationContext';

const useNotifications = () => {
  return useContext(NotificationsContext);
};

export default useNotifications;
